import React from 'react'
import Helmet from 'react-helmet'

const CustomHelmet = props => {
    const { data, fallBack, location } = props
    let title = 'Global Citizen Year'
    if (fallBack && fallBack.title) {
        title = `${fallBack.title} | Global Citizen Year`
    }
    else if (data && data.pageTitle) {
        title = data.pageTitle
    }
    //console.log('ADDITIONAL SCRIPTS === ', data.additionalScripts.internal.content)
    return (
        <div>
            { data &&
                <Helmet
                  title={ title }
                  meta={[
                    { property: 'og:title', content: `${data.openGraphTitle ? data.openGraphTitle : `Global Citizen Year`}` },
                    { property: 'og:description', content: `${data.openGraphDescription ? data.openGraphDescription.openGraphDescription : ``}` },
                    { name: 'description', content: `${data.pageDescription ? data.pageDescription.pageDescription : ``}` },
                    { property: 'og:url', content: 'https://www.globalcitizen.org' + (location ? location.pathname : '' ) },
                    { property: 'og:image', content: `${data.openGraphImage ? data.openGraphImage.file.url : ``}` },
                    { name: 'keywords', content: data.seoKeywords },
                  ]}
                >
                {
                    data.additionalScripts &&
                    <script type="application/ld+json">{data.additionalScripts.internal.content }</script>
                }
                { props.children }
                </Helmet>
            }
        </div>
    )
}

export default CustomHelmet



// WEBPACK FOOTER //
// ./src/components/CustomHelmet/index.js